import _ from 'lodash';

const analyticsTypes = {
  DIRECT_CHECKOUT_VIEW_SELECTIONS: 'directcheckout_Selections_View',
  DIRECT_CHECKOUT_VIEW_REVIEW_ORDER: 'directcheckout_ReviewOrder_View',
  DIRECT_CHECKOUT_VIEW_RECEIPT: 'directcheckout_Receipt_View',
  DIRECT_CHECKOUT_VIEW_PERMANENT_FAILURE: 'directcheckout_PermanentFailure_View',
  DIRECT_CHECKOUT_VIEW_UNCONFIRMED: 'directcheckout_Unconfirmed_View',
  DIRECT_CHECKOUT_ABORT_CONFIRM: 'directcheckout_Abort_Confirm',
  DIRECT_CHECKOUT_ABORT_DISMISS: 'directcheckout_Abort_Dismiss',
  DIRECT_CHCEKOUT_SUCCESS: 'directcheckout_Success',
  DIRECT_CHECKOUT_MESSAGE_CLICK: 'directcheckout_MessageClick'
};

const extractMessageValues = (message, extra) => ({
  message_kind: _.get(message, 'kind'),
  message_value: _.get(message, 'message'),
  ...extra
});

const extractCheckoutValues = checkout => ({
  checkout_id: _.get(checkout, 'id'),
  checkout_status: _.get(checkout, 'status'),
  total_price: _.get(checkout, 'metadata.summary.total.value') / 100,
  subtotal_price: _.get(checkout, 'metadata.summary.subtotal.value') / 100,
  shipping_price: _.get(checkout, 'metadata.summary.shipping.value') / 100,
  tax_price: _.get(checkout, 'metadata.summary.tax.value') / 100,
  total_cash_back: _.get(checkout, 'cart.campaign_discount_overview.campaigns_total_discount') / 100,
  num_items: _.size(_.get(checkout, 'metadata.items'))
});

const extractSupplierValues = supplier => ({
  supplier_id: _.get(supplier, 'id'),
  supplier_short_name: _.get(supplier, 'short_name'),
  supplier_name: _.get(supplier, 'name'),
  supplier_kind: _.get(supplier, 'kind')
});

const extractCheckoutActionValues = (checkout, supplier, extra) => ({
  ...extractCheckoutValues(checkout),
  ...extractSupplierValues(supplier),
  ...extra
});

const analyticsActions = [{
  type: analyticsTypes.DIRECT_CHECKOUT_VIEW_SELECTIONS,
  attributesExtractor: extractCheckoutActionValues
}, {
  type: analyticsTypes.DIRECT_CHECKOUT_VIEW_REVIEW_ORDER,
  attributesExtractor: extractCheckoutActionValues
}, {
  type: analyticsTypes.DIRECT_CHECKOUT_VIEW_RECEIPT,
  attributesExtractor: extractCheckoutActionValues
}, {
  type: analyticsTypes.DIRECT_CHECKOUT_VIEW_PERMANENT_FAILURE,
  attributesExtractor: extractCheckoutActionValues
}, {
  type: analyticsTypes.DIRECT_CHECKOUT_VIEW_UNCONFIRMED,
  attributesExtractor: extractCheckoutActionValues
}, {
  type: analyticsTypes.DIRECT_CHECKOUT_ABORT_CONFIRM,
  attributesExtractor: extractCheckoutActionValues
}, {
  type: analyticsTypes.DIRECT_CHECKOUT_ABORT_DISMISS,
  attributesExtractor: extractCheckoutActionValues
}, {
  type: analyticsTypes.DIRECT_CHCEKOUT_SUCCESS,
  attributesExtractor: extractCheckoutActionValues
}, {
  type: analyticsTypes.DIRECT_CHECKOUT_MESSAGE_CLICK,
  attributesExtractor: extractMessageValues
}];

export {
  analyticsTypes,
  analyticsActions
};
